export default __webpack_public_path__ + "static/media/categorie_icons_Reminder.00d38632.svg";